import store from "../store";
import {commonService} from "./common.service";
import {env} from "../env";

export const parcService = {
  fetchExploitantParcsDownloadFile,
  getParcs,
  getEquipeDrealParcs,
  getParcById,
  putParc,
  getParcLockById,
  getParcUnlockById,
  splitParc,
  getParcReport,
  getAllExploitantParcs
};

function fetchExploitantParcsDownloadFile() {
  const url = new URL(`${env.apiUrl}/parcs/exploitant/download`);
  return commonService.downloadFile(url);
}

// Retourne la liste des parcs
function getParcs(size, searchParams, regionInsee) {
  const url = new URL(`${env.apiUrl}/parcs/`);

  // Paramètre de pagination
  if (size !== null) {
    url.searchParams.append("size", size);
  }

  // Paramètre Adminisatrateur
  if (regionInsee !== null) {
    url.searchParams.append("regionInsee", regionInsee);
  }

  // Paramètres de recherche
  setSearchParams(url, searchParams);

  return commonService.getRessource(url);
}

// Retourne la liste des parcs à scinder en fonction d'un id partiel
function getParcsByPartialId(size, partialId) {
  const url = new URL(`${env.apiUrl}/parcs/to-split`);

  // Paramètre de pagination
  if (size !== null) {
    url.searchParams.append("size", size);
  }

  if (partialId != null || partialId != undefined) {
    url.searchParams.append("partialId", partialId);
  }

  return commonService.getRessource(url);
}

// Retourne la liste des parcs en fonction de l'id de l'équipe DREAL
function getEquipeDrealParcs(equipeDrealId, size, searchParams) {
  const url = new URL(`${env.apiUrl}/parcs/equipes-dreal/${equipeDrealId}`);

  if (size !== null) {
    url.searchParams.append("size", size);
  }

  setSearchParams(url, searchParams);

  return commonService.getRessource(url);
}

// Retourne un parc unlocké en fonction de son id
function getParcUnlockById(parcId) {
  const url = new URL(`${env.apiUrl}/parcs/unlock/${parcId}`);

  return commonService.getRessource(url);
}

// Retourne un parc locké en fonction de son id
function getParcLockById(parcId) {
  const url = new URL(`${env.apiUrl}/parcs/lock/${parcId}`);

  return commonService.getRessource(url);
}

// Retourne un parc en fonction de son id
function getParcById(parcId) {
  const url = new URL(`${env.apiUrl}/parcs/${parcId}`);

  return commonService.getRessource(url);
}

// Retourne la liste des parcs dont l'utilisateur est exploitant
function getAllExploitantParcs(size, searchParams) {
  const url = new URL(`${env.apiUrl}/parcs/exploitant`);

  if (size !== null) {
    url.searchParams.append("size", size);
  }

  setSearchParams(url, searchParams);

  return commonService.getRessource(url);
}

// Scinder un parc
function splitParc(splitParc) {
  console.log(splitParc)
  const url = new URL(`${env.apiUrl}/parcs/split`);
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(splitParc)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

// Met à jour un parc
function putParc(parc) {
  const url = new URL(`${env.apiUrl}/parcs`);
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(parc)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

// Ajoute les paramètres de recherche à l'url
function setSearchParams(url, searchParams) {
  if (searchParams !== null && searchParams !== undefined) {
    if (
      searchParams.regionInsee != null ||
      searchParams.regionInsee != undefined
    ) {
      url.searchParams.append("regionInsee", searchParams.regionInsee);
    }
    if (
      searchParams.departementInsee != null ||
      searchParams.departementInsee != undefined
    ) {
      url.searchParams.append(
        "departementInsee",
        searchParams.departementInsee
      );
    }
    if (
      searchParams.communeInsee != null ||
      searchParams.communeInsee != undefined
    ) {
      url.searchParams.append("communeInsee", searchParams.communeInsee);
    }
    if (
      searchParams.statutSaisieId != null ||
      searchParams.statutSaisieId != undefined
    ) {
      url.searchParams.append("statutSaisieId", searchParams.statutSaisieId);
    }
    if (
      searchParams.statutAdministratifId != null ||
      searchParams.statutAdministratifId != undefined
    ) {
      url.searchParams.append(
        "statutAdministratifId",
        searchParams.statutAdministratifId
      );
    }
    if (
      searchParams.statutParcId != null ||
      searchParams.statutParcId != undefined
    ) {
      url.searchParams.append("statutParcId", searchParams.statutParcId);
    }
    if (
      searchParams.etatParcId != null ||
      searchParams.etatParcId != undefined
    ) {
      url.searchParams.append("etatParcId", searchParams.etatParcId);
    }
    if (
      searchParams.numeroICPE != null ||
      searchParams.numeroICPE != undefined
    ) {
      url.searchParams.append("numeroICPE", searchParams.numeroICPE);
    }
  }
}

// Retourne la liste des parcs
function getParcReport(parcId) {
  const url = new URL(`${env.apiUrl}/parcs/${parcId}/report`);

  return commonService.downloadFile(url);
}
